// extracted by mini-css-extract-plugin
module.exports = {"modal":"VideoModal_modal__22tJI","modalContent":"VideoModal_modalContent__2zotV","close":"VideoModal_close__13Tqp","iframe":"VideoModal_iframe__3yWWS"};